import { z } from 'zod';
/**
 * Health check response schema
 */
export const healthCheckSchema = z.object({
    status: z.enum(['ok', 'degraded', 'down']),
    timestamp: z.string(),
    version: z.string(),
    services: z.record(z.enum(['ok', 'degraded', 'down'])).optional(),
});
/**
 * Error response schema
 */
export const errorResponseSchema = z.object({
    error: z.string(),
    message: z.string(),
    statusCode: z.number(),
    details: z.unknown().optional(),
});
/**
 * Pagination request schema
 */
export const paginationRequestSchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(20),
});
/**
 * Pagination response schema
 */
export const paginationResponseSchema = (dataSchema) => z.object({
    data: z.array(dataSchema),
    pagination: z.object({
        page: z.number(),
        limit: z.number(),
        total: z.number(),
        totalPages: z.number(),
    }),
});
//# sourceMappingURL=common.js.map